import { PrimeIcons } from "primeng/api"

import { LgkNavMenuItem } from "@logick/ui/api"

export const SALES_MENU: LgkNavMenuItem = {
    label: "Vente",
    icon: PrimeIcons.SHOPPING_BAG,
    routerLink: "sales",
    items: [
        {
            label: "Ventes",
            type: "section",
            items: [
                {
                    label: "Accueil des groupes",
                    routerLink: "booking-agenda",
                    featureState: { isLocked: true }
                },
                {
                    label: "Guichet",
                    routerLink: "checkout",
                    featureState: { isLocked: false },
                    routing: { loadComponent: () => import("./checkout/checkout.page").then((it) => it.CheckoutPage) }
                 },
                {
                    label: "Réservations de groupe",
                    routerLink: "group-reservations",
                    featureState: { isLocked: false },
                    routing: {
                        children: [
                            { path: "", pathMatch: "full", loadComponent: () => import("./group-reservations/group-reservation-list/group-reservation-list.page").then((it) => it.GroupReservationListPage) },
                            { path: "new", loadComponent: () => import("./group-reservations/group-reservations.page").then((it) => it.GroupReservationsPage) },
                            { path: ":id", loadComponent: () => import("./group-reservations/group-reservations.page").then((it) => it.GroupReservationsPage) }
                        ]
                    }
                },
            ]
        },
        {
            label: "Documents",
            type: "section",
            items: [
                {
                    label: "Devis",
                    routerLink: "quotes",
                    featureState: { isLocked: true }
                },
                {
                    label: "Factures",
                    routerLink: "invoices",
                    featureState: { isLocked: true }
                },
            ]
        },
        {
            label: "Caisse",
            type: "section",
            items: [
                {
                    label: "Synthèse journalière",
                    routerLink: "daily-stats",
                    featureState: { isLocked: true }
                },
                {
                    label: "Clôtures",
                    routerLink: "register-closing",
                    featureState: { isLocked: true }
                },
            ]
        },

    ]
}
